export default "__VITE_ASSET__CCYdQRPZ__"